import React from 'react'
import CurrencyFormat from 'react-currency-format'


const Expenses = props => {
    const expenses = props.expenses

    return (
        <div className="columns">
            <div className="column">
                <table className='table is-bordered is-fullwidth table-detail'>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>nombre</th>
                            <th>tipo</th>
                            <th>cantidad</th>
                            <th>monto unitario</th>
                            <th>monto solicitado</th>
                            <th>monto aprobado</th>
                            <th>monto ejercido</th>
                        </tr>
                    </thead>
                    <tbody>

                        {expenses.map((expense, key) =>
                            <tr key={key}>
                                <td>{key+1}</td>
                                <td>{expense.name}</td>
                                <td>{expense.expense_type}</td>
                                <td className='has-text-centered'>
                                    <CurrencyFormat
                                        value={parseFloat(expense.quantity) || 0}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                    />
                                </td>
                                <td className='has-text-right'>
                                    <CurrencyFormat
                                        value={parseFloat(expense.unit_amount) || 0}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'}
                                    />
                                </td>
                                <td className='has-text-right'>
                                    <CurrencyFormat
                                        value={parseFloat(expense.application_amount) || 0}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'}
                                    />
                                </td>
                                <td className='has-text-right'>
                                    <CurrencyFormat
                                        value={parseFloat(expense.approved_amount) || 0}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'}
                                    />
                                </td>
                                <td className='has-text-right'>
                                    <CurrencyFormat
                                        value={parseFloat(expense.disbursed_amount) || 0}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'}
                                    />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Expenses


// WEBPACK FOOTER //
// ./src/acervo/components/Sections/Detail/Expenses.js